var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-subnav-tiles" },
    _vm._l(_vm.tiles, function(tile, index) {
      return _c(
        tile.link ? "a" : "div",
        {
          key: tile.headin + "_" + index,
          tag: "div",
          staticClass: "mobile-subnav-tiles__tile",
          attrs: { href: tile.link }
        },
        [
          tile.image
            ? _c("img", { attrs: { src: tile.image.src, alt: tile.image.alt } })
            : _vm._e(),
          _c("div", { staticClass: "mobile-subnav__tile-heading" }, [
            _vm._v(_vm._s(tile.heading))
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }